export default "__VITE_ASSET__UbvrRwBu__"